document.addEventListener('DOMContentLoaded', function() {
  const accordionTitles = document.querySelectorAll('.manual-accordion-title');

  accordionTitles.forEach(title => {
    title.addEventListener('click', function() {
      const currentAccordion = this.parentElement; // Get the parent .manual-accordion
      const currentManualItem = currentAccordion.parentElement; // Get the parent .manual-item

      // Check if the current accordion is already open
      const isOpen = this.classList.contains('active');

      // Close all accordions within the current manual-item
      currentManualItem.querySelectorAll('.manual-accordion-title').forEach(t => {
        t.classList.remove('active');
        t.nextElementSibling.style.display = 'none';
      });

      // Toggle the current accordion if it was closed
      if (!isOpen) {
        this.classList.add('active');
        this.nextElementSibling.style.display = 'block';
      }
    });
  });

  const addSmoothScroll = () => {
    const navigationItems = document.querySelectorAll('.manuals-navigation-item');

    navigationItems.forEach(item => {
      item.addEventListener('click', function() {
        const targetId = this.dataset.target;
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  };

  addSmoothScroll();
});